module.exports = __webpack_public_path__ + "front/img/77.d9e62d8b.png";